var _a, _b;
import { SocialNetwork } from './SocialIcon';
var socialNetworkToKeyMap = (_a = {},
    _a[SocialNetwork.BEHANCE] = 'social.behance',
    _a[SocialNetwork.DRIBBLE] = 'social.dribbble',
    _a[SocialNetwork.ETSY] = 'social.etsy',
    _a[SocialNetwork.FACEBOOK] = 'social.facebook',
    _a[SocialNetwork.FLICKR] = 'social.flickr',
    _a[SocialNetwork.INSTAGRAM] = 'social.instagram',
    _a[SocialNetwork.LINKEDIN] = 'social.linkedin',
    _a[SocialNetwork.PATREON] = 'social.patreon',
    _a[SocialNetwork.PINTEREST] = 'social.pinterest',
    _a[SocialNetwork.TUMBLR] = 'social.tumblr',
    _a[SocialNetwork.TWITCH] = 'social.twitch',
    _a[SocialNetwork.TWITTER] = 'social.twitter',
    _a[SocialNetwork.VIMEO] = 'social.vimeo',
    _a[SocialNetwork.YOUTUBE] = 'social.youtube',
    _a);
export function networkToTranslationKey(network) {
    return socialNetworkToKeyMap[network];
}
export var SocialNetworkUrlRegex = (_b = {},
    _b[SocialNetwork.BEHANCE] = /^(https?:\/\/)?(www\.)?behance\.net\/([\w+\-_=.,#%&$?!*'()]+\/?)+/i,
    _b[SocialNetwork.DRIBBLE] = /^(https?:\/\/)?(www\.)?dribbble\.com\/([\w+\-_=.,#%&$?!*'()]+\/?)+/i,
    _b[SocialNetwork.ETSY] = /^(https?:\/\/)?(www\.)?etsy\.com\/([\w+\-_=.,#%&$?!*'()]+\/?)+/i,
    _b[SocialNetwork.FACEBOOK] = /^(https?:\/\/)?(www\.)?facebook\.com\/([\w+\-_=.,#%&$?!*'()]+\/?)+/i,
    _b[SocialNetwork.FLICKR] = /^(https?:\/\/)?(www\.)?flickr\.com\/([\w+\-_=.,#%&$?!*'()]+\/?)+/i,
    _b[SocialNetwork.INSTAGRAM] = /^(https?:\/\/)?(www\.)?instagram\.com\/([\w+\-_=.,#%&$?!*'()]+\/?)+/i,
    _b[SocialNetwork.LINKEDIN] = /^(https?:\/\/)?(www\.)?linkedin\.com\/([\w+\-_=.,#%&$?!*'()]+\/?)+/i,
    _b[SocialNetwork.PATREON] = /^(https?:\/\/)?(www\.)?patreon\.com\/([\w+\-_=.,#%&$?!*'()]+\/?)+/i,
    _b[SocialNetwork.PINTEREST] = /^(https?:\/\/)?(www\.)?([a-z]{2}\.)?pinterest\.(com|[a-z]{2})\/([\w+\-_=.,#%&$?!*'()]+\/?)+/i,
    _b[SocialNetwork.TUMBLR] = /^(https?:\/\/)?((www\.([\w+\-_=.,#%&$?!*'()]+\/?)+)|((?!(www\.))([\w+\-_=.,#%&$?!*'()]+\/?)+))\.tumblr\.com\/?/i,
    _b[SocialNetwork.TWITCH] = /^(https?:\/\/)?(www\.)?twitch\.tv\/([\w+\-_=.,#%&$?!*'()]+\/?)+/i,
    _b[SocialNetwork.TWITTER] = /^(https?:\/\/)?(www\.)?twitter\.com\/([\w+\-_=.,#%&$?!*'()]+\/?)+/i,
    _b[SocialNetwork.VIMEO] = /^(https?:\/\/)?(www\.)?vimeo\.com\/([\w+\-_=.,#%&$?!*'()]+\/?)+/i,
    _b[SocialNetwork.YOUTUBE] = /^(https?:\/\/)?(www\.)?youtube\.com\/([\w+\-_=.,#%&$?!*'()]+\/?)+/i,
    _b);
export function matchExact(r, str) {
    var match = str.match(r);
    return !!match && str === match[0];
}
//# sourceMappingURL=utils.js.map